var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 600 600"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Icons_Selected_09_Save"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 600,
    height: 600
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons_Selected_09_Save",
    clipPath: "url(#clip-Icons_Selected_09_Save)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons_Selected_09_Save-2",
    "data-name": "Icons_Selected_09_Save",
    transform: "translate(-6.5 4.866)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shadow_Layer",
    transform: "translate(81.032 53.501)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    cx: 262.734,
    cy: 262.734,
    r: 262.734,
    fill: "#eaeaea"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M404.3,49.853,107.188,35.9,36.4,341.175l267.5,63.3Z",
    transform: "translate(71.858 59.121)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7",
    "data-name": "Group 7",
    transform: "translate(6.5 11.3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    "data-name": "Group 5",
    transform: "translate(83.347 68.746)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M440.1,54.642c-.34-4.084-1.021-7.828-3.744-10.55-3.4-3.4-8.849-4.084-14.294-4.765-52.751-6.466-106.523-4.765-155.19-6.126-55.814-1.361-108.225-.34-156.892-1.7H109.3c-1.7.34-3.4.681-4.424,2.042-1.021,1.021-1.361,2.723-1.7,4.084C96.026,63.151,89.22,87.995,82.753,112.5c-7.828,28.928-14.634,57.175-20.76,84.4C50.082,249.651,40.553,300.36,33.406,348.687c-.34,1.361-2.723,15.655-2.382,15.655,79.977,23.483,170.845,45.6,274.986,67.045,6.466,1.361,13.613,2.723,20.079,0,7.147-3.063,10.55-10.55,12.932-17.016q31.14-83.21,59.558-176.631c9.87-32.331,19.4-65.683,28.928-100.057C434.654,111.477,442.141,80.848,440.1,54.642ZM310.093,298.658c-6.126,17.016-10.891,33.693-15.315,50.369-2.382,9.529-5.445,20.079-11.231,28.588-2.723,4.084-5.445,7.487-10.891,7.487-7.487,0-17.357-4.084-24.163-6.126-36.415-8.849-70.788-17.357-103.46-25.525-14.634-3.4-28.588-7.147-42.541-10.55-8.508-2.042-17.357-3.4-25.184-6.807A243,243,0,0,1,84.8,298.658c3.744-12.932,8.168-25.865,12.932-39.138,4.084-10.891,11.231-41.18,23.483-47.306,2.723-1.361,5.786-1.021,8.849-1.021,25.184,2.382,52.751,6.126,79.977,10.55,30.289,4.765,69.087,5.786,99.716,16C333.916,246.248,316.9,279.6,310.093,298.658ZM385.306,78.806c-20.079,41.52-40.159,81.339-60.238,119.115-43.222-4.424-84.4-8.849-123.539-12.933a2.116,2.116,0,0,1-2.042-1.361c-.34-1.361.681-3.744,1.361-5.786,6.807-20.079,14.974-40.839,22.462-61.94,6.126-16.676,12.252-38.457,21.441-56.154C292.4,56,338,62.47,385.646,69.617a1.791,1.791,0,0,1,2.042,2.042C388.029,73.36,386.667,76.083,385.306,78.806Z",
    transform: "translate(-30.99 -31.5)",
    fill: "#f56bd6"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    "data-name": "Group 6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M276.041,550.381C127.317,550.381,6.5,429.564,6.5,280.841S127.317,11.3,276.041,11.3A268.519,268.519,0,0,1,406.387,44.993a8.529,8.529,0,1,1-8.168,14.974,253.575,253.575,0,0,0-121.838-31.31c-139.195,0-252.524,113.33-252.524,252.524S137.186,533.7,276.381,533.7s252.184-114.01,252.184-253.2a259.559,259.559,0,0,0-13.613-82.36c-1.7-4.424.681-9.189,5.445-10.891,4.424-1.7,9.189.681,10.891,5.445a274.694,274.694,0,0,1,14.634,87.8C545.921,429.224,424.764,550.381,276.041,550.381Z",
    transform: "translate(-6.5 -11.3)",
    fill: "#4c4c4c"
  })))))));
};
export default __webpack_public_path__ + "static/media/Icons_Selected_09_Save.a28ffd3d.svg";
export { SvgComponent as ReactComponent };